module.exports = __webpack_public_path__ + "img/Skirt-Front-B2-Db-Fb-Ga-Hc-Ia.ab75c94f.png";